// Accessibility patch: redactor images do not include empty alt attribute.
export default (() => {
    const imagesWithoutAlt = Array.from(document.querySelectorAll('img:not([alt])'));
    imagesWithoutAlt.forEach((img) => {
        img.setAttribute('alt', '');
    });
})();
